import { useQuery } from "@tanstack/react-query";
import { rolesDictionaryService } from "../../services/dictionaries";

export const useRolesDictionary = () => {
    return useQuery({
        queryKey: ["roles", "dictionary"],
        queryFn: (): Promise<string[]> => rolesDictionaryService.getRolesDictionary(),
        staleTime: 1000 * 60 * 15, // 15 minutes
        gcTime: 1000 * 60 * 30, // 30 minutes
    });
};
